import "./LoaderSpinner.scss";

const LoaderSpinner = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner" aria-hidden />
    </div>
  );
};

export default LoaderSpinner;
